import { IState } from './MovementEnquiry.reducer';

export interface IActions {
    [MovementEnquiryActionTypes.setMovementEnquiry]?: IState['MovementEnquiry'];
    [MovementEnquiryActionTypes.setLineNumber]?: IState['LineNumber'];
    [MovementEnquiryActionTypes.setSummaryPanelData]?: IState['SummaryPanelData'];
    [MovementEnquiryActionTypes.setProcessMovementEnquiryDetails]?: IState['ProcessMovementEnquiryDetails'];
    [MovementEnquiryActionTypes.setReloadMovementEnquiry]?: IState['ReloadMovementEnquiry'];
    [MovementEnquiryActionTypes.setIsChangeStatusDisabled]?: IState['IsChangeStatusDisabled'];
    [MovementEnquiryActionTypes.setPreventChangeStatus]?: IState['PreventChangeStatus'];
}

export enum MovementEnquiryActionTypes {
    setMovementEnquiry = 'setMovementEnquiry',
    setLineNumber = 'setLineNumber',
    setSummaryPanelData = 'setSummaryPanelData',
    setProcessMovementEnquiryDetails = 'setProcessMovementEnquiryDetails',
    setReloadMovementEnquiry = 'setReloadMovementEnquiry',
    setIsChangeStatusDisabled = 'setIsChangeStatusDisabled',
    setPreventChangeStatus = 'setPreventChangeStatus'
}
